import React, { PropsWithChildren } from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import styles from "./styles.module.css";

type GridPhoenixLayoutProps = {
  variant?: "no-lines" | "lines";
  className?: string;
};

export const GridPhoenixLayout = ({
  children,
  className,
  variant = "lines",
}: PropsWithChildren<GridPhoenixLayoutProps>) => {
  const cx = createClasses([
    styles.gridLayout,
    className,
    {
      [styles.noLines]: variant === "no-lines",
    },
  ]);

  return (
    <section className={cx} data-variant={variant}>
      {children}
    </section>
  );
};
